import React, { useRef, useEffect, useState } from "react";
import JsBarcode from "jsbarcode";

export default function ShippingLabel(props) {
    const {
        logoUrl = "https://via.placeholder.com/100x60?text=Logo",
        orderNumber = "ORD-123456",
        destinationCode = "RII",
        recipientName = "John Doe",
        deliveryAddress = "123 Street / Apt 4 / Region / City / 123456 / Country",
        barcode = "ABC-abc-1234",
        parcelCount = "1/1",
    } = props;

    const svgRef = useRef(null);

    useEffect(() => {
        if (svgRef.current) {
            try {
                JsBarcode(svgRef.current, orderNumber, {
                    format: "CODE128",
                    displayValue: true,
                    fontSize: 14,
                    width: 2,
                    height: 60,
                    margin: 0,
                });
            } catch (e) {
                console.error("Ошибка генерации штрихкода:", e);
            }
        }
    }, [orderNumber]);

    return (
        <div
            style={{
                width: "600px",
                padding: 20,
                background: "#ccc",
                fontFamily: "Arial, sans-serif",
                border: "1px solid #000",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 10,
                }}
            >
                <img
                    src={logoUrl}
                    alt="Logo"
                    style={{ width: 100, height: 60, border: "1px solid #000" }}
                />
                <div
                    style={{
                        flex: 1,
                        marginLeft: 20,
                        border: "1px solid #000",
                        padding: 5,
                    }}
                >
                    <strong>Order number</strong>
                    <br />
                    {orderNumber}
                </div>
                <div
                    style={{
                        width: 80,
                        border: "1px solid #000",
                        padding: 5,
                        textAlign: "center",
                    }}
                >
                    <strong style={{ fontSize: 12 }}>
                        destination
                        <br />
                        country code
                    </strong>
                    <div style={{ fontSize: 20, marginTop: 5 }}>{destinationCode}</div>
                </div>
            </div>

            <div style={{ border: "1px solid #000", padding: 10, marginBottom: 10 }}>
                <strong>Recipient name</strong>
                <br />
                {recipientName}
            </div>

            <div style={{ border: "1px solid #000", padding: 10, marginBottom: 10 }}>
                <strong>Delivery address</strong>
                <br />
                {deliveryAddress}
            </div>

            <div style={{ display: "flex" }}>
                <div
                    style={{
                        flex: 2,
                        border: "1px solid #000",
                        padding: 10,
                        marginRight: 10,
                        textAlign: "center",
                    }}
                >
                    <strong>Barcode and parcel number</strong>
                    <br />
                    <div style={{ marginTop: 10 }}>
                        {/* Вот здесь SVG с штрихкодом */}
                        <svg ref={svgRef} />
                    </div>
                </div>
                <div
                    style={{
                        flex: 1,
                        border: "1px solid #000",
                        padding: 10,
                        textAlign: "center",
                    }}
                >
                    <strong>parcel number/ total number of parcels in the order</strong>
                    <div style={{ fontSize: 24, marginTop: 10 }}>{parcelCount}</div>
                </div>
            </div>
        </div>
    );
};